import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-starts-at',
  templateUrl: './starts-at.component.html',
  styleUrls: ['./starts-at.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class StartsAtComponent implements OnInit {
  startsAtCtrl:FormControl; // date value
  maxDate:Date;
  @Input('ctrl') ctrl:FormControl;  // number value 
  @Input() disabled:boolean = false;
  private subscriptions = new Subscription();

  constructor(
    private localeService:BsLocaleService,
    private cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) public localeId: string    
  ) { 
    this.localeService.use(localeId);    

  }
  createControls () {
    const starts_at_date = new Date(this.ctrl && this.ctrl.value || Date.now());
    this.startsAtCtrl = new FormControl(this.fixTimezoneOffset(starts_at_date));
  }  
  private fixTimezoneOffset (d:Date):Date {
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0));    
  }
  ngOnInit(): void {
    this.maxDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    this.createControls();

    this.subscriptions.add(
      this.startsAtCtrl.valueChanges
      .subscribe((date_from_picker:Date)=>{
        if (!this.ctrl) return;

        const date_from_outside = new Date(this.ctrl.value);
        if (date_from_picker.toDateString() === date_from_outside.toDateString()) return;

        date_from_outside.setFullYear(date_from_picker.getFullYear(), date_from_picker.getMonth(), date_from_picker.getDate());
        this.ctrl.setValue(date_from_outside.getTime());
      })
    );
    
    if (this.ctrl) this.subscriptions.add(
      this.ctrl.valueChanges
      .pipe(
        map(ts=>new Date(ts)),
      )
      .subscribe((date_from_outside:Date)=>{

        const date_from_picker:Date = new Date(this.startsAtCtrl.value && this.startsAtCtrl.value.getTime());
        if (date_from_picker.toDateString() === date_from_outside.toDateString()) return;
        
        date_from_picker.setFullYear(date_from_outside.getFullYear(), date_from_outside.getMonth(), date_from_outside.getDate());
        this.startsAtCtrl.setValue(date_from_picker)
        this.cdRef.detectChanges();
      })
    )
    this.startsAtCtrl.updateValueAndValidity();
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }
}
